export function objectExists(object) {
  return object && Object.keys(object).length !== 0;
}